function NumberInput({ element }) {
  const decreaseButton = element.querySelector(".decrease-button");
  const increaseButton = element.querySelector(".increase-button");
  const input = element.querySelector(".input");

  decreaseButton.addEventListener("click", function () {
    input.value = Math.max(parseInt(input.value) - 1, input.min || -Infinity);
  });

  increaseButton.addEventListener("click", function () {
    input.value = Math.min(parseInt(input.value) + 1, input.max || Infinity);
  });
}
